import React, { useEffect, useContext } from 'react';
import { AuthContext } from '../context/AuthContext';
import { useNavigate, Navigate } from 'react-router-dom';
import {
  Container,
  Paper,
  Typography,
  Box,
  CircularProgress
} from '@mui/material';
import UserManagement from '../components/projects/UserManagement';
import { usePermissions } from '../hooks/usePermissions';
import { PERMISSIONS } from '../config/permissions';
import { useTheme as useMuiTheme } from '@mui/material/styles';

export default function EmployeeManagement() {
  const { user, role, loading, roleLoading } = useContext(AuthContext);
  const { hasPermission } = usePermissions();
  const muiTheme = useMuiTheme();

  if (loading || roleLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
          <CircularProgress />
          <Typography sx={{ ml: 2 }}>Laden van gebruikersgegevens...</Typography>
        </Box>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  const canManage = hasPermission(PERMISSIONS.MANAGE_EMPLOYEES);
  if (!canManage) {
    return <Navigate to="/" replace />;
  }

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'background.default' }}>
      {/* Header */}
      <Paper elevation={0} sx={{
        background: `linear-gradient(135deg, ${muiTheme.palette.primary.main} 0%, ${muiTheme.palette.primary.dark} 100%)`,
        color: 'primary.contrastText',
        py: 4,
        px: { xs: 2, md: 4 },
        mb: 2,
        borderRadius: 0,
        textAlign: 'center',
        width: '100vw',
        position: 'relative',
        left: '50%',
        right: '50%',
        marginLeft: '-50vw',
        marginRight: '-50vw',
        minWidth: '100vw',
        maxWidth: '100vw',
      }}>
        <Typography variant="h4" sx={{ fontWeight: 700, mb: 1 }}>
          Werknemersbeheer
        </Typography>
        <Typography variant="body1" sx={{ opacity: 0.9 }}>
          Beheer en autoriseer medewerkers van je organisatie
        </Typography>
      </Paper>
      <Container maxWidth="lg" sx={{ mt: 2 }}>
        <Paper elevation={2} sx={{ p: { xs: 2, md: 4 }, borderRadius: 3 }}>
        <UserManagement />
      </Paper>
    </Container>
    </Box>
  );
}
